import React from 'react'

export const Logo = () => {
  return (
    <>
      <span className="sr-only">Sitefile</span>
      <svg
        fill="#fff"
        height="100%"
        viewBox="0 0 112 20.04"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <path
          fill="#fff"
          d="M17.58,20.46H3.89a3.9,3.9,0,0,1,0-7.79H14.57a1.26,1.26,0,0,1,0,2.52H3.89a1.38,1.38,0,0,0,0,2.75H17.58a3.12,3.12,0,1,0,0-6.23H5.63A5.64,5.64,0,0,1,5.63.44h13.7a3.89,3.89,0,1,1,0,7.78H8.65a1.26,1.26,0,1,1,0-2.52H19.33a1.37,1.37,0,1,0,0-2.74H5.63a3.12,3.12,0,0,0,0,6.23h12a5.64,5.64,0,1,1,0,11.27Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M33.52,5.72C33.52,4.07,34.94,3,37.29,3s4,1.31,4.17,3.33h2.82A6.08,6.08,0,0,0,42.18,2,7.34,7.34,0,0,0,37.29.44a7.47,7.47,0,0,0-4.81,1.45,4.63,4.63,0,0,0-1.87,3.83,4.65,4.65,0,0,0,.84,2.83c1.09,1.56,2.79,2.06,4.72,2.65,2.77.81,5.54,1.26,5.54,3.61,0,2-1.68,3.07-4.25,3.07a4.27,4.27,0,0,1-4.64-4.13H30c.23,4.11,3.08,6.71,7.47,6.71a8.34,8.34,0,0,0,5.23-1.54,4.94,4.94,0,0,0,2-4.14C44.67,7.34,33.52,10.45,33.52,5.72Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M56.67.44H54v5.7H46.85V20.23h2.71V8.49H54v7.13a4.29,4.29,0,0,0,4.67,4.61h2.2V17.88h-2a2.07,2.07,0,0,1-2.18-2.34v-7h4.16V6.14H56.67Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M68.34,8.12a3.69,3.69,0,0,1,3.94,3.58h-8C64.71,9.32,66.08,8.12,68.34,8.12Zm.28,10c-2.46,0-4.19-1.79-4.42-4.48H75c0-.33,0-.7,0-1.06a6.77,6.77,0,0,0-1.76-4.75,6.36,6.36,0,0,0-4.92-1.93,6.28,6.28,0,0,0-5,2,7.51,7.51,0,0,0-1.82,5.14,7.33,7.33,0,0,0,2,5.2,6.63,6.63,0,0,0,5.11,2.16c3.47,0,6-1.9,6.52-4.81H72.42C72,17.32,70.75,18.16,68.62,18.16Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M87.58,6.14H81.26V4.86a1.9,1.9,0,0,1,2.13-2.07h2.12V.44H83.19C80.37.44,78.55,2,78.55,4.77V6.14H75.67V8.49h2.88V20.23h2.71V8.49h6.32V20.23h2.71V6.14H87.58Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M96.09.49H93.38v19.8h2.71Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M105.21,8.12a3.7,3.7,0,0,1,3.94,3.58h-8C101.57,9.32,102.94,8.12,105.21,8.12Zm4.08,7.55c-.42,1.65-1.68,2.49-3.8,2.49-2.46,0-4.2-1.79-4.42-4.48h10.76c0-.33.06-.7.06-1.06a6.81,6.81,0,0,0-1.76-4.75,6.39,6.39,0,0,0-4.92-1.93,6.29,6.29,0,0,0-5,2,7.56,7.56,0,0,0-1.82,5.14,7.33,7.33,0,0,0,2,5.2,6.64,6.64,0,0,0,5.12,2.16c3.46,0,6-1.9,6.51-4.81Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M48.21,3.81a1.69,1.69,0,1,0-1.69-1.68A1.69,1.69,0,0,0,48.21,3.81Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M88.93.44a1.69,1.69,0,1,0,1.69,1.69A1.68,1.68,0,0,0,88.93.44Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M33.51,5.71C33.51,4.07,34.93,3,37.28,3s4,1.32,4.16,3.33h2.81A6,6,0,0,0,42.16,2,7.33,7.33,0,0,0,37.28.44a7.44,7.44,0,0,0-4.8,1.45,4.61,4.61,0,0,0-1.87,3.82,4.6,4.6,0,0,0,.84,2.82c1.08,1.56,2.79,2.07,4.71,2.65,2.76.81,5.53,1.26,5.53,3.6,0,2-1.68,3.07-4.24,3.07a4.27,4.27,0,0,1-4.64-4.13H30c.23,4.1,3.07,6.7,7.46,6.7a8.23,8.23,0,0,0,5.21-1.54,4.91,4.91,0,0,0,2-4.13C44.64,7.33,33.51,10.43,33.51,5.71Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M56.65.44H53.94V6.13H46.85V20.19h2.71V8.47h4.38v7.12a4.28,4.28,0,0,0,4.66,4.6h2.21V17.85h-2a2.07,2.07,0,0,1-2.18-2.34v-7h4.16V6.13H56.65V.44Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M68.3,8.09a3.69,3.69,0,0,1,3.94,3.57h-8C64.67,9.29,66,8.09,68.3,8.09Zm.28,10c-2.45,0-4.18-1.79-4.41-4.47H74.92c0-.33,0-.7,0-1.06a6.74,6.74,0,0,0-1.76-4.74A6.34,6.34,0,0,0,68.3,5.91a6.26,6.26,0,0,0-5,2,7.55,7.55,0,0,0-1.82,5.13,7.36,7.36,0,0,0,1.95,5.19,6.64,6.64,0,0,0,5.11,2.15c3.46,0,6-1.9,6.5-4.8h-2.7C72,17.27,70.7,18.11,68.58,18.11Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M87.47,6.13h-6.3V4.85a1.9,1.9,0,0,1,2.12-2.07h2.12V.44H83.09C80.28.44,78.46,2,78.46,4.76V6.13H75.59V8.47h2.87V20.19h2.71V8.47h6.3V20.19h2.71V6.13H87.47Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M96,.49h-2.7V20.25H96Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M105.06,8.09A3.68,3.68,0,0,1,109,11.66h-8C101.43,9.29,102.8,8.09,105.06,8.09Zm4.07,7.53c-.42,1.65-1.67,2.49-3.8,2.49-2.45,0-4.18-1.79-4.4-4.47h10.74c0-.33.06-.7.06-1.06A6.79,6.79,0,0,0,110,7.84a6.35,6.35,0,0,0-4.91-1.93,6.27,6.27,0,0,0-5,2,7.55,7.55,0,0,0-1.81,5.13,7.36,7.36,0,0,0,2,5.19,6.6,6.6,0,0,0,5.1,2.15c3.47,0,6-1.9,6.51-4.8Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M48.18,3.81a1.69,1.69,0,1,0,0-3.37,1.69,1.69,0,0,0,0,3.37Z"
          transform="translate(0 -0.44)"
        />
        <path
          fill="#fff"
          d="M88.82.44a1.69,1.69,0,0,0,0,3.37,1.69,1.69,0,1,0,0-3.37"
          transform="translate(0 -0.44)"
        />
      </svg>
    </>
  )
}
